/**
 * 首页 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = "/api/";

const index = {
  // 是否置灰
  config(params) {
    return axios.get(api + "gwh/config", { params: params });
  },
  // 首页
  index(params) {
    return axios.get(api + "gwh/index", { params: params });
  },
  // 获取导航
  catelist(params) {
    return axios.get(api + "gwh/catelist", { params: params });
  },
  // 获取文章列表
  articlelist(params) {
    return axios.get(api + "gwh/articlelist", { params: params });
  },
  // 获取领导信息
  leadarticlelist(params) {
    return axios.get(api + "gwh/leadarticlelist", { params: params });
  },
  // 获取领导信息详情
  leadarticledetail(params) {
    return axios.get(api + "gwh/leadarticledetail", { params: params });
  },
  // 文章详情
  articledetail(params) {
    return axios.get(api + "gwh/articledetail", { params: params });
  },
  // 发表留言
  postmsg(params) {
    return axios.post(api + "gwh/postmsg", qs.stringify(params));
  },
  // 发表疫情防控
  posttousu(params) {
    return axios.post(api + "gwh/posttousu", qs.stringify(params));
  },
  // 获取留言列表
  msg(params) {
    return axios.get(api + "gwh/msg", { params: params });
  },
  // 获取留言数和回复数
  msgset(params) {
    return axios.get(api + "gwh/msgset", { params: params });
  },
  // 顾问团队列表
  guwenteam(params) {
    return axios.get(api + "gwh/guwenteam", { params: params });
  },
  // 搜索页
  search(params) {
    return axios.get(api + "gwh/search", { params: params });
  },
  // 视频列表
  videolist(params) {
    return axios.get(api + "gwh/videolist", { params: params });
  },
  // 视频详情
  videodetail(params) {
    return axios.get(api + "gwh/videodetail", { params: params });
  },
  // 新媒看新区
  xinqulist(params) {
    return axios.get(api + "gwh/xinqulist", { params: params });
  },
  // 管委会首页外链
  link(params) {
    return axios.get(api + "gwh/link", { params: params });
  },
  // 国务要闻 第三方接口
  // guowulist(params) {
  //   return axios.get("http://www.gov.cn/pushinfo/v150203/base_14px_pubdate.htm", { params: params });
  // },
};

// 导出接口
export default index;
